// extracted by mini-css-extract-plugin
export var dividerContainer = "_72-0";
export var line = "_72-1";